import React from "react";
import Header from "../../Shard/Navbar/Header";
import SearchResult from "./Search/SearchResult/SearchResult";
import "./Booking.css";
import SearchHeading from "../../Home/HomePages/Search/SearchHeading";
import Footer from "../../Shard/Footer/Footer";

const Booking = ({
  isShaw,
  setIsShaw,
  equipmentsData,
  equipmentLoading,
  productData,
  vehicleData,
}) => {
  return (
    <div className="booking">
      <Header isShaw={isShaw} setIsShaw={setIsShaw} />
      <SearchHeading
        equipmentsData={equipmentsData}
        productData={productData}
        vehicleData={vehicleData}
        equipmentLoading={equipmentLoading}
      />
      <SearchResult />
      <Footer />
    </div>
  );
};

export default Booking;
